import { render, staticRenderFns } from "./addClose.vue?vue&type=template&id=7794f5d4&"
import script from "./addClose.vue?vue&type=script&lang=js&"
export * from "./addClose.vue?vue&type=script&lang=js&"
import style0 from "./addClose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports